import {
    Border,
    Colors,
    Outline,
    ZIndex,
    shortStandardTransition,
} from "@ptml/design-system";
import React from "react";
import styled, { css } from "styled-components";

const BaseStyles = css`
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    height: 24px;
`;
export const UnstyledContainer = styled.div<{
    $isFinished: boolean;
    $isShort: boolean;
    $color?: "blue" | "purple";
}>`
    ${BaseStyles}

    gap: 4px;
`;
export const Container = styled.div<{
    $isFinished: boolean;
    $isShort: boolean;
    $color?: "blue" | "purple";
}>`
    ${BaseStyles}
    width: calc(100% - var(--elements-sidebar-width) - 1rem);
    height: ${({ $isShort }) => ($isShort ? "24px" : "72px")};
    padding: 0 44px;
    position: fixed;
    background-color: rgba(255, 255, 255, 0.8);

    border-top: 1px solid ${Colors.Grey50};

    bottom: 0;
    z-index: ${({ $isFinished }) => ($isFinished ? 1 : ZIndex.AlwaysOnTop)};
    opacity: ${({ $isFinished }) => ($isFinished ? 0 : 1)};
    transform: ${({ $isFinished }) =>
        $isFinished ? "translateY(15%)" : "translateY(0%)"};

    transition:
        opacity ${shortStandardTransition},
        transform ${shortStandardTransition};

    ${({ theme }) => css`
        &:focus {
            outline: ${theme.outline.small};
            outline-offset: ${Outline.offset.tiny};
        }
    `}
`;

export const BackgroundContainer = styled.div`
    background-color: ${({ theme }) => theme.sidebar.background};
    position: fixed;
    width: 2rem;
    height: 2rem;
    left: var(--elements-sidebar-width);
    bottom: 0;
    z-index: ${ZIndex.Default + 1};

    transition: left 220ms cubic-bezier(0.2, 0, 0, 1);
`;

export const CurveContainer = styled.div`
    background-color: ${Colors.White};
    border-bottom-left-radius: ${Border.Radius.Size[16]};
    position: fixed;
    bottom: 0;
    left: var(--elements-sidebar-width);
    height: 2rem;
    width: 2rem;
    z-index: ${ZIndex.OnTop};

    transition: left 220ms cubic-bezier(0.2, 0, 0, 1);
`;

export const Bar = styled.div<{
    $progress: number;
    $duration: number;
    $color?: "blue" | "purple";
}>`
    height: 8px;

    left: 0;
    position: relative;
    top: 0;
    width: 100%;
    z-index: inherit;
    overflow: hidden;
    border-radius: 4px;

    &::before {
        content: "";
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${({ $color }) => {
            if ($color === "blue") {
                return Colors.ProgressBarBlue;
            }
            if ($color === "purple") {
                return Colors.Purple30;
            }
            return Colors.Grey50;
        }};
        will-change: margin-left;
        margin-left: ${({ $progress }) => {
            return `${(-1 + $progress) * 100}%`;
        }};
        transition: ${({ $duration }) => {
            return `marginLeft ${$duration}ms linear`;
        }};
    }

    &::after {
        content: "";
        z-index: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background: ${({ $color }) => {
            if ($color === "blue") {
                return Colors.Blue16;
            }

            return Colors.Grey01;
        }};
    }
`;

export const Counter = styled.div<{ children?: React.ReactNode }>`
    min-width: 30px;
`;
